/**
 * Program Fee 1043 — BDU Fee Structure
 *
 * Reuses the Program Fee 1 matrix, relabelled for BDU's shape:
 *   Fee Type  (tab)    = Student type — "Indian Students", "International Students"
 *   Semester  (column) = Fee plan     — "SEMESTER", "ANNUAL", "LUMPSUM"
 *   Category  (row)    = Line item    — "Semester 1", "Year 1", "Lumpsum"
 *   Value     (cell)   = the amount, as a plain number (e.g. 23500)
 *
 * A line item with no value for the selected plan is skipped, so the plans can hold
 * different line items. The total row is the SUM of the visible amounts — do not add
 * a "Total" line item or it will be counted twice.
 */

export const PROGRAM_FEE_1043_CONSTANTS = {
  PROGRAM_FEE_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Fee Structure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Fee Structure",
      required: false,
      defaultValue: "Fee Structure",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#222023",
    },
    {
      fieldName: "gradient_color_1",
      label: "Heading rule below 768px — start (blue)",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Heading rule below 768px — end (blue)",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "gradient_color_3",
      label: "Selected pill / table header — gradient top",
      value: "#F50113",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F50113",
    },
    {
      fieldName: "gradient_color_4",
      label: "Selected pill / table header — gradient bottom",
      value: "#A30113",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#A30113",
    },
    {
      fieldName: "table_header_background_color",
      label: "Selected fee plan + total row surface",
      value: "#FFDCDE",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFDCDE",
    },
    {
      fieldName: "section_background_image",
      label: "Section background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload full-bleed background",
      required: false,
      defaultValue: "",
      filterCategory: "images",
    },
    {
      fieldName: "other_fee",
      label: "Disclaimer band (rich text — leave empty to hide)",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Additional processing fee, exam fees, one-time payments…",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Disclaimer band fill",
      value: "#836537",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#836537",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
  ],
};
